import { useFormikContext } from 'formik';
import classnames from 'classnames';
import { useTranslation } from 'react-i18next';
import { LOAN_GROUPS_IDS } from '@/helpers/constants';
import { useGetInvestingStatus } from '@/query/queries/investing/useGetInvestingStatus';
import { RangeField } from '../RangeField';
import { InvestmentGroup } from '../InvestmentGroup';
import { InvestmentTerm } from '../InvestmentTerm';
import s from './index.module.scss';

export const Settings = ({ state }) => {
  const { values, setFieldValue } = useFormikContext();
  const { t } = useTranslation('calculator');
  const { data: status } = useGetInvestingStatus();

  const onInvestmentChange = value => {
    setFieldValue('initial', value);
  };

  const onMonthlyInvestmentChange = value => {
    setFieldValue('monthly_investment', value);
  };

  const onTermChange = value => {
    setFieldValue('term', value);
  };

  return (
    <div className={s.wrapper}>
      <RangeField
        label={
          status?.is_active ? t('growth.current_round') : t('growth.next_round')
        }
        value={values.initial}
        step={50}
        min={Number(state?.initial_investment_range.left) || 0}
        max={Number(state?.initial_investment_range.right) || 0}
        onInputChange={onInvestmentChange}
        onRangeChange={onInvestmentChange}
      />
      <div className={s.group}>
        <RangeField
          label={t('growth.monthly_investment')}
          value={values.monthly_investment}
          step={50}
          min={Number(state?.monthly_investment_range.left) || 0}
          max={Number(state?.monthly_investment_range.right) || 0}
          onInputChange={onMonthlyInvestmentChange}
          onRangeChange={onMonthlyInvestmentChange}
        />
        {values.group_id === LOAN_GROUPS_IDS.conservative.id && (
          <div className={classnames(s.description, 'f-small-regular')}>
            {t('growth.get_1_percent_income_on_group_a_loans')}
          </div>
        )}
      </div>
      <InvestmentTerm
        value={values.term}
        min={Number(state?.investment_term_range.left) || 0}
        max={Number(state?.investment_term_range.right) || 0}
        onRangeChange={onTermChange}
        description={t('growth.investment_term_description')}
      />
      <InvestmentGroup />
    </div>
  );
};
